// @vendor
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const WizardError = require('components/commons/wizardError/wizardError');

class CardDownloadPDFError extends React.Component {
    render() {
        const { immCard } = this.props;
        const cardId = immCard.get('cardId');
        const title = formatText('cardDownloadPDF-cardDownloadPDF_errorTitle');
        const goBackButtonLabel = (
            <FormattedText
                injectedStrings={[immCard.getIn(['alias','current'])]}
                value="cardDownloadPDF-cardDownloadPDF_backToCard"
            />
        );
        const goBackButton = {
            label: goBackButtonLabel,
            url: `/myprofile/cards/${cardId}/details`
        }


        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10 col-lg-offset-2 col-lg-8">
                <WizardError
                    errorMessage={title}
                    mainButton={goBackButton}
                >
                    <section>
                        <div>
                            <FormattedText
                                value="cardDownloadPDF-cardDownloadPDF_errorSubMessage"
                                className="contract-view__wizard-error-sub-message"
                            />
                        </div>
                    </section>
                </WizardError>
            </div>
        )
    }
}

CardDownloadPDFError.propTypes = {
    immCard: PropTypes.object.isRequired,
};

module.exports = CardDownloadPDFError;
